<!-- 图文导航 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1">样式设置</MenuItem>
                <MenuItem name="2">内容设置</MenuItem>
                <MenuItem name="3">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData.content" label-position="left" :label-width="80">
                        <div class="form-title">导航样式</div>
                        <FormItem label="导航样式">
                            <div class="flex-sb w80">
                                <div :class="newFormData.content.type_id == 1 ? 'nav-active' : 'nav'" @click="changeNav(1)">
                                    <img v-if="newFormData.content.type_id == 1" src="@/assets/diy/icon1-active.png"/>
                                    <img v-else src="@/assets/diy/icon1.png"/>
                                    <span>图标导航</span>
                                </div>
                                <div :class="newFormData.content.type_id == 2 ? 'nav-active' : 'nav'" @click="changeNav(2)">
                                    <img v-if="newFormData.content.type_id == 2" src="@/assets/diy/icon2-active.png"/>
                                    <img v-else src="@/assets/diy/icon2.png"/>
                                    <span>文字导航</span>
                                </div>
                                <div :class="newFormData.content.type_id == 3 ? 'nav-active' : 'nav'" @click="changeNav(3)">
                                    <img v-if="newFormData.content.type_id == 3" src="@/assets/diy/icon3-active.png"/>
                                    <img v-else src="@/assets/diy/icon3.png"/>
                                    <span>图片导航</span>
                                </div>
                            </div>
                        </FormItem>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData.content" label-position="right" :label-width="80">
                        <FormItem v-if="newFormData.content.type_id == 1 || newFormData.content.type_id == 2" label="文字颜色">
                            <ColorPicker v-model="newFormData.content.text_color"/>
                        </FormItem>
                        <FormItem label="图片高度">
                            <div class="right-navs">
                                <div class="right-nav" v-for="(item, index) of newFormData.content.iconList" :key="index">
                                    <img class="form-img" src="@/assets/homeset/del.png" @click.stop="delIcons(index)"/>
                                    <div class="right-uploads" v-if="newFormData.content.type_id == 1 || newFormData.content.type_id == 3" @click="openModal(index)">
                                        <img class="upload-img" v-if="item.picview" :src="item.picview"/>
                                        <Icon v-else type="md-add" size="50" color="#C0C4CC"/>
                                    </div>
                                    <div style="flex: 1">
                                        <Input v-if="newFormData.content.type_id == 1 || newFormData.content.type_id == 2" v-model="item.title" placeholder="标题">
                                            <span slot="prepend">标题</span>
                                        </Input>
                                        <Input class="mt-6" v-if="newFormData.content.type_id == 1 || newFormData.content.type_id == 2" v-model="item.describe"
                                            placeholder="功能描述"
                                        >
                                            <span slot="prepend">说明</span>
                                        </Input>
                                        <Select class="mt-6" v-model="item.action_id" filterable placeholder="跳转动作">
                                            <Option v-for="item in actionList" :value="item.id" :key="item.id" >{{ item.name }}</Option>
                                        </Select>
                                        <Input class="mt-6" v-if="item.action_id == 1" v-model="item.link_name" placeholder="请输入外部链接（http/https）"></Input>
                                        <Select class="mt-6" v-if="item.action_id == 2" v-model="item.link_id" filterable placeholder="跳转链接">
                                            <Option v-for="item in linkList" :value="item.id" :key="item.id" >{{ item.title }}</Option>
                                        </Select>
                                    </div>
                                </div>
                                <div class="add-div">
                                    <img class="w20" src="@/assets/homeset/plus.png"  @click="addIcons"/>
                                    <div class="add-txt" @click="addIcons">添加</div>
                                </div>
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 3">
                    <Form :model="newFormData" label-position="right" :label-width="80">
                        <div class="form-title">组件间距</div>
                        <FormItem label="上下间距"><Slider class="w300" v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider class="w300" v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider class="w300" v-model=" newFormData.content.marginData.topRadius"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider class="w300" v-model=" newFormData.content.marginData.bottomRadius"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            srctype: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            actionList: [],
        };
    },
    mounted() {
        if (this.diy_id == 1) {
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 3, name: "扫一扫" },
            ];
        } else {
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 3, name: "扫一扫" },
            ];
        }
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.iconList[this.srctype].picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.iconList[this.srctype].value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
            this.srctype = index;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeNav(i) {
            this.newFormData.content.type_id = i;
        },
        // 删除
        delIcons(i) {
            if (this.newFormData.content.iconList.length == 1) {
                this.$Message.info("至少保留一张");
            } else {
                this.newFormData.content.iconList.splice(i, 1);
            }
        },
        // 添加
        addIcons() {
            this.newFormData.content.iconList.push({
                value: "/img/diy/smail.png",
                picview: "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                title: "标题",
                describe: "功能描述",
                action_id: 1,
                link_id: 1,
                link_name: "",
            });
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.w80 {
    width: 80%;;
}
.nav {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.nav-active {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #fe761d;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #fe761d;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.right-navs {
    padding: 12px;
    width: 80%;
    border: 1px solid #c0c4cc;
}
.right-nav {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #c0c4cc;
    display: flex;
    position: relative;
}
.form-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    cursor: pointer;
}
.right-uploads {
    margin: 0 12px 0 0;
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.upload-img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
    border: 1px solid #fff;
}
.mt-6 {
    margin: 6px 0 0 0;
}
.add-div {
    display: flex;
    align-items: center;
}
.w20 {
    width: 20px; 
    height: 20px;
    cursor: pointer;
}
.add-txt {
    font-size: 14px;
    color: #ff761d;
    cursor: pointer;
}
</style>